/* eslint-disable no-case-declarations */
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import {
  GET_GUESTS_DATA,
  GET_GUEST_EXCEPTION,
  GET_RESERVATION_LIST,
  GET_HISTORY_ATTRIBUTE,
  GET_HISTORY,
  ADD_GUEST_INFORMATION,
  GET_INCLUDE_RESERVATION_GUESTS_DATA,
  GET_PERSON_DETAILS,
  GET_TRAVEL_PARTY,
  SHOW_MINOR_ERROR,
  GET_STATEROOM_GUESTS_LIST,
  GET_STATEROOM_PARTY,
  GET_STATEROOM_GUESTS_DATA,
  GET_RESERVATION_PARTY,
  GET_RESERVATION_GUESTS,
  GET_VOYAGE_WITH
} from './../constants/actionTypes'

const initStore = {
  persons: [],
  pages: {}
}

const guests = (store = initStore, action = {}) => {
  switch (action.type) {
    case GET_GUESTS_DATA:
      const page = get(action, 'data.page', {})
      let persons = []
      if (isEmpty(page) || page.page === 1 || page.number === 1) {
        if (!isEmpty(action?.data?.data?._embedded)) {
          persons =
            action?.data?.data?._embedded?.reservationGuestSearchResult
              ?.reservationGuests
        } else {
          persons = get(action, 'data.persons', [])
        }
      } else {
        persons = [
          ...get(store, 'persons', []),
          ...get(action, 'data.persons', [])
        ]
      }
      return {
        page,
        persons
      }
    default:
      return store
  }
}
const stateroomGuests = (store = initStore, action = {}) => {
  if (action.type === GET_STATEROOM_GUESTS_DATA && action.data.data._embedded) {
    return action.data.data._embedded.reservationGuestDetailsResponses
  } else {
    return store
  }
}
const reservationGuests = (store = [], action = {}) => {
  if (action.type === GET_RESERVATION_GUESTS) {
    return action.data.data._embedded.reservationGuests
  } else {
    return store
  }
}
const reservationExceptionGuests = (store = [], action = {}) => {
  if (action.type === GET_GUEST_EXCEPTION) {
    return action.data.data
  } else {
    return store
  }
}
const minorError = (store = [], action = {}) => {
  if (action.type === SHOW_MINOR_ERROR) {
    return action.data
  } else {
    return store
  }
}
const guestIAMPersonDetail = (store = [], action = {}) => {
  if (action.type === GET_PERSON_DETAILS) {
    return action.data
  } else {
    return store
  }
}
const guestAttribute = (store = [], action = {}) => {
  if (action.type === GET_HISTORY_ATTRIBUTE) {
    return action.data.data._embedded
  } else {
    return store
  }
}

const includeReservationGuests = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_INCLUDE_RESERVATION_GUESTS_DATA:
      const page = get(action, 'data.page', '')
      let persons = []
      if (page === 1) {
        persons = get(action, 'data.data._embedded.personsSearchResult', {})
      } else {
        persons = {
          ...get(store, 'persons', []),
          ...get(action, 'data.data._embedded.personsSearchResult', {})
        }
      }
      return {
        page,
        persons
      }
    default:
      return store
  }
}

const includeReservationPartyList = (store = {}, action = {}) => {
  if (action.type === GET_RESERVATION_LIST && action.data.data._embedded) {
    return action.data.data._embedded.personsSearchResult
  } else {
    return store
  }
}

const reservationParty = (store = {}, action = {}) => {
  if (action.type === GET_RESERVATION_PARTY && action.data.data) {
    return action.data.data
  } else {
    return store
  }
}

const guestInformation = (store = {}, action = {}) => {
  if (action.type === ADD_GUEST_INFORMATION) {
    return action.data
  } else {
    return store
  }
}

const guestHistory = (store = {}, action = {}) => {
  if (action.type === GET_HISTORY) {
    return action.data
  } else {
    return store
  }
}

const stateroomParty = (store = {}, action = {}) => {
  if (action.type === GET_STATEROOM_PARTY && action.data) {
    return action.data
  } else {
    return store
  }
}

const voyageWithParty = (store = {}, action = {}) => {
  if (action.type === GET_VOYAGE_WITH && action.data) {
    return action.data
  } else {
    return store
  }
}

const travelParty = (store = {}, action = {}) => {
  if (action.type === GET_TRAVEL_PARTY) {
    if (action.data.data._embedded) {
      return action.data.data._embedded.connectionDetailsResponses
    } else {
      return []
    }
  } else {
    return store
  }
}
const stateroomGuestsList = (store = {}, action = {}) => {
  if (action.type === GET_STATEROOM_GUESTS_LIST && action.data.data._embedded) {
    return action.data.data._embedded
  } else {
    return store
  }
}

export {
  reservationExceptionGuests,
  guests,
  guestAttribute,
  guestIAMPersonDetail,
  guestInformation,
  minorError,
  includeReservationPartyList,
  guestHistory,
  includeReservationGuests,
  stateroomGuestsList,
  travelParty,
  stateroomParty,
  stateroomGuests,
  reservationParty,
  reservationGuests,
  voyageWithParty
}
